import { adminMarketingQueryKeys as e } from "./adminMarketingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminMarketingApi as n } from "@maat/api-main";
//#region src/marketing/admin/useMarketingAnalyticsQuery.ts
var r = (r, i) => t({
	queryKey: e.analytics(r, i),
	queryFn: () => n.getAnalytics(r, i),
	enabled: !!r
});
//#endregion
export { r as useMarketingAnalyticsQuery };
